import { useTranslation } from "react-i18next";
import { CustomButtonTable } from "../../../../components/CustomButtonTable/CustomButtonTable";
import { CustomIconButton } from "../../../../components/CustomIconButton/CustomIconButton";
import { CustomTypography } from "../../../../components/CustomTypography/CustomTypography";
import { CustomTypographyLabelValue } from "../../../../components/CustomTypographyLabelValue/CustomTypographyLabelValue";
import useStyles from "./styles";
import { useNavigate, useParams } from "react-router";
import {
  useGetSinisterById,
  useGetSinisterEmployee,
} from "../../../../api/sinistre";
import { getCurrentFleetId } from "../../../../utils/getCurrentFleet";
import { paths } from "../../../../routes/paths";

export const SectionCollaboratorClaims = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { id = "" } = useParams();
  const navigate = useNavigate();
  const sinisterId = parseInt(id);
  const { sinisterDetail } = useGetSinisterById(
    getCurrentFleetId(),
    sinisterId
  );

  const { sinisterEmployee } = useGetSinisterEmployee(
    getCurrentFleetId(),
    sinisterDetail?.vehicle_id ?? 0,
    sinisterId
  );

  // The collaborator's id comes from the SINISTER, not from the employee
  // payload: TSinisterEmployee carries only display fields (name, email,
  // department...) and no identifier, so there is nothing in it to route
  // on. sinisterDetail.user_id is the collaborator this claim belongs to.
  const collaboratorId = sinisterDetail?.user_id;

  // Both controls lead to the collaborator's own page, which is where a
  // collaborator is edited. This card is a read-only summary of the claim
  // and has no endpoint of its own for changing employee details.
  const goToCollaborator = () => {
    if (!collaboratorId) return;
    navigate(paths.collaborator.update(collaboratorId));
  };

  return (
    <div className={classes.divSinisterInfos}>
      <div className={classes.divCollaborator}>
        <CustomTypography
          text={t("panel.collaborator.collaborator", "Collaborator")}
          variant="h3"
          isUppercase
        />
        {!!collaboratorId && (
          <CustomIconButton
            iconName={"pencil"}
            widthIcon={"30px"}
            heightIcon={"30px"}
            onClick={goToCollaborator}
          />
        )}
      </div>
      <div className={classes.divInfosSinister}>
        <div className={classes.divInfosSinisterColums}>
          <CustomTypographyLabelValue
            label={t("collaborator.name", "Name")}
            value={sinisterEmployee?.lastname ?? ""}
          />
          <CustomTypographyLabelValue
            label={t("collaborator.firstName", "Firstname")}
            value={sinisterEmployee?.firstname ?? ""}
          />
          <CustomTypographyLabelValue
            label={t(
              "collaborator.vehicleAllocationTime",
              "Vehicle allocation time"
            )}
            value={`${sinisterEmployee?.jours ?? ""} ${t(
              "common.days",
              "Days"
            )}`}
          />
        </div>
        <div className={classes.divInfosSinisterColums}>
          <CustomTypographyLabelValue
            label={t("collaborator.service", "Service")}
            value={sinisterEmployee?.department ?? ""}
          />
          <CustomTypographyLabelValue
            label={t("collaborator.email", "Email")}
            value={sinisterEmployee?.email ?? ""}
          />
        </div>
        <div className={classes.divInfosSinisterColums}>
          {sinisterEmployee?.site && (
            <CustomTypographyLabelValue
              label={"Site"}
              value={sinisterEmployee.site}
            />
          )}
          {sinisterEmployee?.permis && (
            <CustomTypographyLabelValue
              label={t("collaborator.licenseNumber", "License number")}
              value={sinisterEmployee.permis}
            />
          )}
        </div>
      </div>
      <CustomButtonTable
        variant={"primary"}
        textVariant={"link"}
        label={t("claims.seeTheCollaboratorFile", "See the collaborator file")}
        width={"fit-content"}
        fontWeight={"bold"}
        textDecoration={"none"}
        textTransform="uppercase"
        iconName={"eye"}
        // Disabled rather than silently inert when the claim has no linked
        // user (legacy rows, or a collaborator removed from the fleet):
        // a button that looks clickable and does nothing reads as a bug.
        disabled={!collaboratorId}
        onClick={goToCollaborator}
      />
    </div>
  );
};
